<template>
  <div class="width-100">
    <div
      v-for="(item, index) in conditions"
      :class="['col-md-12', 'container-condition', 'p-0', {disabled: disabled}]">
      <div class="select">
        <div class="input-group width-100 height-100">
          <div class="input-group-prepend width-100 height-100">
            <button
              :disabled="disabled"
              class="btn width-100 height-100 dropdown-custom"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span>
                <span v-if="item.condition === '>='">
                  {{ $t('message.conditiongreaterequal') }}
                </span>
                <span v-else-if="item.condition === '='">
                  {{ $t('message.conditionequal') }}
                </span>
                <span v-else>
                  {{ $t('message.conditionlessthanequal') }}
                </span>
              </span>
              <span>
                <i class="fas fa-caret-down"/>
              </span>
            </button>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                @click="conditions[index].condition = '>='"
              >
                {{ $t('message.conditiongreaterequal') }}
              </a>
              <a
                class="dropdown-item"
                @click="conditions[index].condition = '='"
              >
                {{ $t('message.conditionequal') }}
              </a>
              <a
                class="dropdown-item"
                @click="conditions[index].condition = '<='"
              >
                {{ $t('message.conditionlessthanequal') }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="quantity">
        <input
          v-model="item.quantity"
          :placeholder="$t('message.quantity')"
          :disabled="disabled"
          type="text"
          class="form-control text-select-all"
          @keypress="numberOnly"
          @keyup="conditions[index].quantity = setToValidNumber(item.quantity)"
          @blur="parseInt(conditions[index].quantity) > 0 ? conditions[index].quantity = setToCustomDigitsNumber(item.quantity) : conditions[index].quantity = null"
          @focus="handleInputFocus($event, index)"
        >
      </div>
      <div class="value_amount">
        <span class="line"/>
        <input
          v-model="item.value_amount"
          :placeholder="$t('message.discount')"
          :disabled="disabled"
          type="text"
          class="form-control text-select-all"
          @keypress="numberOnly"
          @keyup="conditions[index].value_amount = setToValidNumber(item.value_amount)"
          @blur="parseInt(conditions[index].value_amount) > 0 ? conditions[index].value_amount = setToCustomDigitsNumber(item.value_amount) : conditions[index].value_amount = null"
          @focus="handleInputFocus(this, index)"
        >
        <div class="input-group height-100">
          <div class="input-group-prepend height-100">
            <button
              :disabled="disabled"
              class="btn height-100 dropdown-custom"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span>
                <span v-if="item.value_type === 'percentage'">%</span>
                <span v-else>{{ currency }}</span>
              </span>
              <span style="margin-left: 10px;">
                <i class="fas fa-caret-down"/>
              </span>
            </button>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                @click="conditions[index].value_type = 'percentage'"
              >
                %
              </a>
              <a
                class="dropdown-item"
                @click="conditions[index].value_type = 'number'"
              >
                {{ currency }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="delete">
        <button
          v-if="index < conditions.length - 1"
          :disabled="disabled"
          class="btn width-100 height-100"
          @click="handleRemove(index)"
        >
          <i class="far fa-trash-alt"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DiscountCondition',

  props: {
    value: {
      type: Array,
    },

    page: {
      type: String,
      required: true,
      validator: (value) => {
        return [
          'new',
          'edit',
        ].includes(value)
      },
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      conditions: [],
    }
  },

  computed: {
    ...mapGetters({
      currency: 'getCurrency',
    }),
  },

  watch: {
    conditions: {
      handler () {
        this.$emit('input', this.conditions)
      },
      deep: true,
    },
  },

  created () {
    this.conditions = this.value

    if (this.conditions.length === 0 || (this.page === 'edit' && !this.disabled)) {
      this.add()
    }
  },

  methods: {
    handleInputFocus (event, index) {
      const isLast = this.conditions.length - 1 === index
      if (isLast) {
        this.add()
      }
    },

    handleRemove (index) {
      this.conditions.splice(index, 1)
    },

    add () {
      this.conditions.push({
        condition: '>=',
        quantity: null,
        value_amount: null,
        value_type: 'percentage',
      })
    },
  },
}
</script>

<style scoped>
.container-condition {
  display: flex;
  border: solid 1px #D8E2E7;
  border-bottom: none;
  background: #fff;
  height: 40px;
}

.container-condition:last-of-type {
  border-bottom: solid 1px #D8E2E7;
}

.container-condition .select {
  min-width: 168px;
}

.container-condition .quantity,
.container-condition .value_amount {
  flex: 1;
  position: relative;
}

.container-condition .value_amount .input-group {
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
}

.container-condition .value_amount .input-group .dropdown-custom {
  padding-right: 0;
}

.container-condition .delete {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #BBBBBB;
}

.container-condition.disabled .delete {
  background-color: #e9ecef;
}

.container-condition .delete button {
  box-shadow: none;
}

.container-condition input[type="text"] {
  height: 100%;
  border: none;
  border-radius: 0;
}

.dropdown-custom {
  display: flex;
  justify-content: space-between;
  box-shadow: none;
  background: none !important;
}

.container-condition .line {
  position: absolute;
  top: 50%;
  left: 0;
  width: 1px;
  height: 40%;
  background: #D8E2E7;
  transform: translateY(-50%);
}

button {
  border-radius: 0;
}

button:disabled {
  background-color: #e9ecef !important;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/DiscountCondition.vue